import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import {
  getPlanPriceRecommendations,
  PlanPriceRecommendationData,
} from "./plansApi";

/**
 * Hook for fetching plan price recommendations
 *
 * @param options Optional query configuration options
 * @returns React Query result with price recommendations data
 */
export function usePlanPriceRecommendationsQuery(
  options?: UseQueryOptions<PlanPriceRecommendationData>,
  enabled?: boolean,
) {
  return useQuery({
    ...options,
    queryKey: ["plan-price-recommendations"],
    queryFn: () => getPlanPriceRecommendations(),
    enabled,
  });
}
